<div class="betting-section">
  <!-- <div *ngIf="mode === modeType.Paused; else pausedSection" class="input-container">
    <div class="items-center justify-center text-center">
      <p class="text-2xl font-bold">Game is paused</p>
    </div>
  </div>
  <ng-template #pausedSection>
    <div *ngIf="showWaitingForOtherTables; else playingSection" class="input-container">
      <div class="items-center justify-center text-center">
        <p class="text-2xl font-bold">WAITING FOR OTHER TABLES TO FINISH</p>
      </div>
    </div>
  </ng-template>
  <ng-template #playingSection> -->
  <!-- <div class="" *ngIf="showBuyIn; else bettingSection">
    <h3 class="insufficient-message" *ngIf="chips < allowedChipsToBuyin">Insuficient balance</h3>
  </div> -->
  <div
    *ngIf="showWaitingForTurn && !showWaitingForOtherTables"
    class="default-overlay absolute left-0 top-0 z-50 h-full !content-start pt-[5rem]"
  >
    <div class="text-center">
      <p class="text-2xl font-bold">Please wait for your turn</p>
    </div>
  </div>

  <div
    *ngIf="showWaitingForOtherTables"
    class="default-overlay absolute left-0 top-0 z-50 h-full !content-start pt-[5rem]"
  >
    <div class="text-center">
      <p class="text-xl font-bold">Please wait for other tables to finish</p>
    </div>
  </div>

  <ng-container *ngIf="showBuyIn; else bettingSection">
    <div class="">
      <h3 class="insufficient-message" *ngIf="chips < allowedChipsToBuyin; else buyInButton">
        Insufficient balance
      </h3>
    </div>
    <ng-template #buyInButton>
      <button
        class="btn-secondary-v3 mt-2 !h-12 w-full md:!h-14"
        (click)="onClickBuyIn()"
        [disabled]="disableBuyIn || showSpinner"
        *ngIf="mode === modeType.BuyInOpen && !currentSeat"
      >
        <div class="text-lg font-black leading-[18px] tracking-wide text-white">
          {{ buyInLabel }}
        </div>
      </button>
    </ng-template>
  </ng-container>

  <ng-template #bettingSection>
    <fieldset>
      <ng-container>
        <div class="easypick-container" [ngClass]="{ 'opacity-50': isBetLock || !isPlayerTurn }">
          @for (easyPick of _classicService.easyPicks; track $index) {
            <button
              class="bet"
              (click)="onClickEasyPick(easyPick.value)"
              [disabled]="isBetLock || (disableEasyPick(easyPick.value) && $index > 0)"
            >
              <div class="coin-container"></div>
              <div class="inner-circle">
                <div class="circle-text text-sm">
                  {{ disableEasyPick(easyPick.value) && $index > 0 ? '' : easyPick.name }}
                </div>
              </div>
            </button>
          }
        </div>

        <div
          class="grid grid-cols-4 gap-1 md:mt-2"
          [ngClass]="{ 'opacity-50': isBetLock || !isPlayerTurn }"
        >
          <div class="col-span-3 flex items-center">
            <div class="bet-input">
              <input
                placeholder="Type in your custom bet amount here."
                type="number"
                min="0"
                appTwoDigitDecimalNumber
                [disabled]="isBetLock"
                type="text"
                [(ngModel)]="betAmount"
                appTwoDigitDecimalNumber
              />
            </div>
          </div>
          <div
            class="flex flex-col items-center rounded-md bg-black bg-opacity-20 backdrop-blur-md"
          >
            <label class="font-bold">PAYOUT</label>
            <label class="font-bold">{{ getPayout(+betAmount) | number: '0.0-2' }}</label>
          </div>
        </div>

        <div class="betting-buttons" [ngClass]="{ 'opacity-50': isBetLock || !isPlayerTurn }">
          <button
            class="bet-option active"
            [ngClass]="{
              'btn-default-v3': selectedBet === betType.HIGHER,
              'btn-secondary-v3 ': !selectedBet || selectedBet !== betType.HIGHER
            }"
            (click)="onClickSetBet(betType.HIGHER)"
            [disabled]="disableBetting || !isPair"
            [class.hidden]="!isPair"
          >
            High
          </button>
          <button
            class="bet-option"
            [ngClass]="{
              'btn-default-v3': selectedBet === betType.LOWER,
              'btn-secondary-v3 ': !selectedBet || selectedBet !== betType.LOWER
            }"
            (click)="onClickSetBet(betType.LOWER)"
            [disabled]="disableBetting || !isPair"
            [class.hidden]="!isPair"
          >
            Low
          </button>

          <button
            class="bet-option"
            [ngClass]="{
              'btn-default-v3': selectedBet === betType.CALL,
              'btn-secondary-v3 ': !selectedBet || selectedBet !== betType.CALL
            }"
            (click)="onClickSetBet(betType.CALL)"
            [disabled]="disableBetting || isPair"
            [class.hidden]="isPair"
          >
            Call
          </button>
          <button
            class="bet-option"
            [ngClass]="{
              'btn-default-v3': selectedBet === betType.FOLD,
              'btn-secondary-v3 ': !selectedBet || selectedBet !== betType.FOLD
            }"
            (click)="onClickFoldBet()"
            [disabled]="isBetLock"
          >
            Fold
          </button>
        </div>
      </ng-container>
    </fieldset>
  </ng-template>
  <!-- </ng-template> -->

  <app-modal [showModal]="showChipsRequestModal" (closeEmitter)="showChipsRequestModal = false">
    <app-chips-request
      *ngIf="showChipsRequestModal"
      (onSuccess)="showChipsRequestModal = false"
    ></app-chips-request>
  </app-modal>
  <app-sm-spinner class="mt-4 w-full text-center" *ngIf="showSpinner"></app-sm-spinner>
</div>
